import './css/index.css';
import { array, bool, func } from 'prop-types';
import React, { useEffect } from 'react';


const toggleClass = ( status ) => {

    return status ? 'toggle-on' : 'toggle-off';

};

const Toggle = ( { active, setActive, labels, customFunc } ) => {


    const handleClick = () => {

        setActive( !active );

        if ( customFunc ) {

            customFunc( !active );

        }

    };

    useEffect( () => {

        if ( customFunc ) {

            customFunc( active );

        }

    }, [] );

    return (

        <div className='toggle-button' onClick={ handleClick }>

            <div className='toggle-container'>

                <div className={ `toggle-btn ${ toggleClass( !active ) }` }
                    dangerouslySetInnerHTML={{ __html: labels[0] }}
                >
                </div>

                <div className={ `toggle-btn ${ toggleClass( active ) }` }
                    dangerouslySetInnerHTML={{ __html: labels[1] }}
                >
                </div>

            </div>

        </div>

    );

};

Toggle.propTypes = {
    active: bool,
    setActive: func,
    labels: array,
    customFunc: func
};


export { Toggle };